import React, { useEffect, useState } from 'react'
import "./style.scss"
import { Form } from 'react-bootstrap'
import StopCircleIcon from '../../../../icons/StopCircleIcon'
import { useDispatch } from 'react-redux';
import DeleteModal from '../../../../components/deleteModal';
import { DeleteModalType } from '../../../../constants/utlis';
import { useNavigate } from 'react-router-dom';
import { all_routes } from '../../../../feature-module/router/all_routes';
import { getSubscriptionOverview, planAutoRenewal, updateEmailNotification } from '../../../data/redux/pricing/_pricingAction';
import moment from 'moment';
import { toast } from 'react-toastify';

interface SettingsTabProps {
  onNavigateToTab?: (tab: string) => void;
  activeTab?: string;
}


const SettingsTab: React.FC<SettingsTabProps> = ({ onNavigateToTab, activeTab }) => {
  const dispatch: any = useDispatch();
  const navigate = useNavigate();
  const routes: any = all_routes;

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [modalType, setModalType] = useState<DeleteModalType>("");
  const [billingOverview, setBillingOverview] = useState<any>({});
  const [emailNotifications, setEmailNotifications] = useState<boolean>(false);
  const [autoRenewal, setAutoRenewal] = useState<boolean>(false);
  const IOS = "ios"

  useEffect(() => {
    if (activeTab === "Settings") {
      getBillingOverview();
    }
  }, [activeTab]);

  const getBillingOverview = async () => {
    try {
      const response = await dispatch(getSubscriptionOverview());
      setBillingOverview(response?.payload?.data);
      setEmailNotifications(response?.payload?.data?.email_notifications);
      setAutoRenewal(response?.payload?.data?.auto_renewal);
      return;
    } catch (error) {
      console.error("Failed to fetch billing overview:", error);
    }
  };

  const handleOpenDeleteModal = (type: DeleteModalType) => {
    setModalType(type);
    setShowDeleteModal(true);
  };

  const handleCancelSubscription = () => {
    if (billingOverview?.platform === IOS) {
      toast.error("This subscription was purchased through the iOS app. Please cancel your subscription from the iOS App Store.");
      return;
    }

    handleOpenDeleteModal("cancelSubscription");
  };


  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false);
  };

  // Handle successful deletion
  const handleDeleteSuccess = () => {
    getBillingOverview();
    setShowDeleteModal(false);
  };

  const canceledAtDate = billingOverview?.current_period_end ? moment(billingOverview.current_period_end).format("MMMM D, YYYY") : null;

  const handleToggleEmailNotification = async () => {
    const newValue = !emailNotifications;
    setEmailNotifications(newValue); // Optimistic UI update

    try {
      await dispatch(updateEmailNotification({ email_notifications: newValue }));
      // Optionally re-fetch overview if needed
      setBillingOverview((prev: any) => ({
        ...prev,
        email_notifications: newValue,
      }));
    } catch (error) {
      console.error("Failed to update email notification:", error);
      // revert if failed
      setEmailNotifications(!newValue);
    }
  };

  const handleAutoRenewal = async () => {
    const newValue = !autoRenewal;
    setAutoRenewal(newValue); // Optimistic UI update

    try {
      await dispatch(planAutoRenewal({ auto_renew: newValue }));
      // Optionally re-fetch overview if needed
      setBillingOverview((prev: any) => ({
        ...prev,
        auto_renewal: newValue,
      }));
    } catch (error) {
      console.error("Failed to update auto renewal:", error);
      // revert if failed
      setAutoRenewal(!newValue);
    }
  };


  return (
    <div className='settingsTab'>

      {(billingOverview?.platform === IOS) ? (
        <div className="subscriptionSetting iosNote">
          <h3>Subscription Settings</h3>
          <p className="text-start text-muted">
            This subscription was purchased through the iOS app.
            Please manage or cancel your subscription directly from the Apple App Store.
          </p>
        </div>
      ) : (
        <div className='subscriptionSetting'>
          <h3>Subscription Settings</h3>
          <p className='text-start'>Manage Plans, Payments, Preferences Easily</p>

          <div className='update d-flex justify-content-between gap-3 align-items-center mb-3'>
            <div>
              <label>Auto-Renewal</label>
              <p className='my-0 text-start'>Automatically renew your subscription</p>
            </div>
            <Form.Check
              type="switch"
              id="custom-switch"
              disabled={billingOverview?.cancel_at_period_end && !billingOverview?.auto_renewal}
              checked={autoRenewal}
              onChange={handleAutoRenewal}
            />
          </div>

          <div className='update d-flex justify-content-between gap-3 align-items-center'>
            <div>
              <label>Email Notification</label>
              <p className='my-0 text-start'>Receive billing and payment notifications</p>
            </div>
            <Form.Check
              type="switch"
              id="custom-switch"
              checked={emailNotifications}
              onChange={handleToggleEmailNotification}
            />
          </div>
        </div>
      )}

      {/* Show message if subscription is already cancelled */}
      {billingOverview?.cancel_at_period_end ? (
        <div className='dnagerBlock'>
          <div className='cancelledMessage text-center'>
            <h4 className='text-danger'>Subscription Cancelled</h4>
            <p>Your subscription has been cancelled and will end on <strong>{canceledAtDate}</strong>.</p>
          </div>
        </div>
      ) : (
        <div className='dnagerBlock'>
          <h3><StopCircleIcon /> Danger Zone</h3>
          <p className='text-start'>Proceed Carefully, Irreversible Actions Ahead</p>
          <div className='cancel-subscription'>
            <h4>Cancel Subscription</h4>
            <p className='text-start my-0'>Once you cancel, you’ll lose access to all features at the end of your current billing period.</p>
            <button
              className='cancel-subs-Btn'
              onClick={() => handleCancelSubscription()}
            >
              Cancel Subscription
            </button>
          </div>
        </div>
      )}


      <DeleteModal
        show={showDeleteModal}
        onHide={handleCloseDeleteModal}
        type={modalType}
        onSuccess={handleDeleteSuccess}
      />
    </div>
  )
}

export default SettingsTab